import React, { useState } from 'react'
import './styles.scss'

import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'

// colors
const violet = '#A756A3'
const red = '#D3343F'
const orange = '#D07800'
const yellow = '#f9c764'
const green = '#2CA29F'
const grey = '#D4D4D4'

const useRows = [
  'HistoricalEmissions, excl forestry',
  'CurrentPolicy projections',
  'DifferenceDownArea',
  'DifferenceUpperArea',
  'NDCUnconditionalMax',
  'ParisAgreement'
]

const csvDataAssessment = require('./Saudia-Assessment-2020.csv')
const csvDataEffortSharing = require('./Saudia-EffortSharing-2020.csv')
const rows = Object.entries(csvDataAssessment)
  .filter(el => useRows.indexOf(el[1].labels) !== -1)
  .map(m => m[1])

// console.log("saudia", rows)

const column = Object.entries(csvDataEffortSharing).map(el => el[1]['2030'])


const values = Object.values(rows[0]).filter(e => e.length < 10)
const valuesCurrentPolicyOne = Object.values(rows[1]).filter(e => e.length < 10)
const valuesCurrentPolicyTwo = Object.values(rows[2]).filter(e => e.length < 10)
const valuesDifferenceDownArea = Object.values(rows[3]).filter(e => e.length < 10)
const valuesDifferenceUpArea = Object.values(rows[4]).filter(e => e.length < 10)
const valuesNDC = Object.values(rows[5]).filter(e => e.length < 10)
const valuesParis = Object.values(rows[6]).filter(e => e.length < 10)

// console.log('paris',valuesParis)
// console.log('policyOne', valuesCurrentPolicyOne)
console.log('DifferenceUp',valuesDifferenceUpArea)

// const valuesArea = valuesCurrentPolicyOne.map((el, index) => {
//   console.log('area', +(el - valuesCurrentPolicyTwo[index]))
//   if (el - valuesCurrentPolicyTwo[index] !== '' && valuesCurrentPolicyTwo[index] !== '')
//     return Math.abs(el - valuesCurrentPolicyTwo[index])
// })

const keys = Object.keys(csvDataAssessment[0]).filter(e => e.length < 5)

const exklCurrentPolicy = valuesCurrentPolicyOne.filter((el, index) => {
  if (valuesCurrentPolicyOne[index] !== '') return el
})

// xy coordinate for label policy line
const xCurrentPolicy = 2030 - Math.round((exklCurrentPolicy.length - 1) / 2)
const yCurrentPolicy =
  exklCurrentPolicy[Math.floor((exklCurrentPolicy.length - 1) / 2)]

// console.log(rowHistorical)
console.log('1.5', column[4])

function SparkLineSaudiaArabia(props) {

  const [isMobile,setIsMobile] = useState(window.innerWidth<650);

  echarts.registerTheme('ta_theme', {
    backgroundColor: 'transparent',
    textStyle: {
      fontSize: '16',
      fontFamily:
        'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
      color: '#333'
    },
    title: {
      textStyle: {
        color: '#333',
        fontSize: '22'
      },
      subtextStyle: {
        color: '#5f5f5f',
        fontSize: '18'
      }
    },
    legend: {
      left: 'left',
      orient: 'vertical',
      itemGap: 7,
      padding: [0, 0, 0, 20],
      itemWidth: 10,
      textStyle: {
        fontSize: '16'
      },
      show: false
    },
    label: {
      show: false
    },
    smooth: true
  })

  return (
    <ReactEcharts
      style={{ height: '340px' }}
      opts={{ renderer: 'canvas' }}
      notMerge
      lazyUpdate
      theme='ta_theme'
      option={{
        grid: [
          {
            top: '12%',
            left: 4,
            right: 14,
            bottom: 10,
            containLabel: true
          }
        ],
        legend: {
          data: ['Line Current policy projections', 'Line NDC']
        },

        // tooltip: {
        //   trigger: 'axis',
        //   position: 'left',
        //   axisPointer: {
        //     type: 'shadow'
        //   },
        //   formatter: function(params, ticket, callback) {
        //     // console.log('#### params ####', params)
        //     // get date
        //     let currDate = params[0].axisValue.match(/\d+/g)
        //     const currYear = currDate[0]

        //     currDate = currYear
        //     const title = '<div class="tip-title">' + currDate + '</div>'
        //     let tooltipContent = title + '<hr class="under" />'
        //     let valuesAreNull = true
        //     for (let i = 0; i < params.length; i++) {
        //       if (params[i].value > -0.00000000001) {
        //         const dotColor = params[i].color
        //         tooltipContent += '<div class="row">'
        //         tooltipContent += '<span class="dot" style="background-color:'
        //         tooltipContent += dotColor
        //         tooltipContent += '">&nbsp;</span>'
        //         tooltipContent += params[i].seriesName + ': '
        //         tooltipContent +=
        //           '<span class="weighted">' +
        //           (Math.round(params[i].value * 10) / 10)
        //             .toString()
        //             .replace(/\./g, ',') + // round to 1 decimal place, replace dot with comma
        //           '</span></div>'
        //         valuesAreNull = false
        //       }
        //     }
        //     // callback(console.log('scrubbed to: ', params[0].dataIndex))
        //     if (!valuesAreNull) {
        //       return tooltipContent
        //     }
        //   }
        // },

        xAxis: {
          type: 'category',
          z: -2,
          axisTick: { show: false },
          splitLine: { show: false },
          axisLine: {
            show: false
          },
          boundaryGap: false,
          data: [...new Set(keys)],
          axisLabel: {
            formatter: function(value) {
              const yearOnly = value.substring(0, 4)
              return yearOnly
            },
            interval: isMobile ? 19 : 9,
          }

        },
        yAxis: {
          type: 'value',
          name: 'MtCO₂/Jahr',
          nameLocation: 'end',
          nameGap: 16,
          nameTextStyle: {
            padding: [0, 0, 0,-40],
            fontSize: 12,
            align: 'left',
          },
          z: -2,
          max: 1500,
          interval: 300,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: function(value, index) {
              if (value > 9999) {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
            } else {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "")
            }},
          }
        },
        series: [

          {
            name: '1.5 Line',
            type: 'line',
            animationDelay: 1000,
            z: -1,
            showSymbol: false,
            markLine: {
              lineStyle: {
                normal: {
                  type: 'solid',
                  color: green,
                  width: 4
                }
              },
              data: [
                [
                  {
                    coord: ['2030', column[5]],
                    symbol: 'none',

                    label: {
                      position: [20, 100]
                    }
                  },
                  {
                    coord: ['2030', column[4]],
                    symbol: 'none'
                  }
                ]
              ]
            },
            markPoint: {
              data: [
                {
                  name: '1.5 label',
                  coord: ['2030', column[4]],
                  symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
                  //   data: 20,
                  symbolSize: 0.1,
                  symbolOffset: [0,-12],
                  itemStyle: {
                    color: green,
                  },
                  label: {
                    // position: [5, 0],
                    position: [4,12],
                    formatter: ['{b|+1,5°C}'].join('\n'),
                    // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
                    rich: {
                      b: {
                        fontSize: 12,
                        color: '#fff',
                        padding: [3, 4, 5, 4],
                        backgroundColor: green
                      }
                    }
                  },
                  // symbolSize: 0.1,
                  animationDelay: 1250
                }
              ]
            }
          },
          {
            name: '2Compatible Line',
            type: 'line',
            animationDelay: 1000,
            z: -1,
            showSymbol: false,
            markLine: {
              lineStyle: {
                normal: {
                  type: 'solid',
                  color: yellow,
                  width: 4
                }
              },
              data: [
                [
                  {
                    coord: ['2030', column[4]],
                    symbol: 'none',

                    label: {
                      position: [20, 100]
                    }
                  },
                  {
                    coord: ['2030', column[3]],
                    symbol: 'none'
                  }
                ]
              ]
            },
            // markPoint: {
            //   data: [
            //     {
            //       name: '2Compatible label',
            //       coord: ['2030', column[3]],
            //       symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
            //       //   data: 20,
            //       symbolSize: 0.1,
            //       symbolOffset: [0,-12],
            //       itemStyle: {
            //         color: yellow,
            //       },
            //       label: {
            //         // position: [5, 0],
            //         position: [4,12],
            //         formatter: ['{b|+1.5-2°C}'].join('\n'),
            //         // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
            //         rich: {
            //           b: {
            //             fontSize: 12,
            //             color: TATypo,
            //             padding: [3, 4, 5, 4],
            //             backgroundColor: yellow
            //           }
            //         }
            //       },
            //       // symbolSize: 0.1,
            //       animationDelay: 1250
            //     }
            //   ]
            // }
          },
          {
            name: 'insufficientLine',
            type: 'line',
            animationDelay: 1000,
            z: -1,
            showSymbol: false,
            markLine: {
              lineStyle: {
                normal: {
                  type: 'solid',
                  color: orange,
                  width: 4
                }
              },
              data: [
                [
                  {
                    coord: ['2030', column[2]],
                    symbol: 'none',

                    label: {
                      position: [20, 100]
                    }
                  },
                  {
                    coord: ['2030', column[3]],
                    symbol: 'none'
                  }
                ]
              ]
            },
            // markPoint: {
            //   data: [
            //     {
            //       name: 'insufficient label',
            //       coord: ['2030', column[2]],
            //       symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
            //       //   data: 20,
            //       symbolSize: 44,
            //       symbolOffset: [30,'50%'],
            //       itemStyle: {
            //         color: orange,
            //       },
            //       label: {
            //         // position: [5, 0],
            //         position: [1,12],
            //         formatter: ['{b|+2-3°C}'].join('\n'),
            //         // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
            //         rich: {
            //           b: {
            //             fontSize: 12,
            //             color: '#fff',
            //             padding: [3, 4, 5, 4],
            //             // backgroundColor: '#fc954f'
            //           }
            //         }
            //       },
            //       // symbolSize: 0.1,
            //       animationDelay: 1250
            //     }
            //   ]
            // }
          },

          {
            name: 'highlyinsufficientLine',
            type: 'line',
            animationDelay: 1000,
            z: -1,
            showSymbol: false,
            markLine: {
              lineStyle: {
                normal: {
                  type: 'solid',
                  color: red,
                  width: 4
                }
              },
              data: [
                [
                  {
                    coord: ['2030', column[2]],
                    symbol: 'none',

                    label: {
                      position: 'middle'
                    }
                  },
                  {
                    coord: ['2030', column[1]],
                    symbol: 'none'
                  }
                ]
              ]
            },
            markPoint: {
              data: [
                {
                  name: 'highly insufficient label',
                  coord: ['2030', column[1]],
                  symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
                    data: 20,
                  symbolSize: 0.1,
                  symbolOffset: [0,-12],
                  itemStyle: {
                    color: red,
                  },
                  label: {
                    position: [4,12],
                    formatter: ['{b|+3-4°C}'].join('\n'),
                    // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
                    rich: {
                      b: {
                        fontSize: 12,
                        color: '#fff',
                        padding: [5, 4, 5, 4],
                        backgroundColor: red
                      }
                    }
                  },
                  animationDelay: 1250
                }
              ]
            }
          },

          {
            name: 'critically insufficient Line',
            type: 'line',
            animationDelay: 1000,
            z: -1,
            showSymbol: false,
            markLine: {
              lineStyle: {
                normal: {
                  type: 'solid',
                  color: violet,
                  width: 4
                }
              },
              data: [
                [
                  {
                    coord: ['2030', column[1]],
                    symbol: 'none',

                    label: {
                      position: 'middle'
                    }
                  },
                  {
                    coord: ['2030', column[0]],
                    symbol: 'none'
                  }
                ]
              ]
            },
            markPoint: {
              data: [
                {
                  name: 'critically insufficient label',
                  coord: ['2030', column[0]],
                  symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
                  //   data: 20,
                  symbolSize: 0.1,
                  symbolOffset: [0,-12],
                  itemStyle: {
                    color: violet,
                  },
                  label: {
                    position: [4,12],
                    formatter: ['{b|+4°C}'].join('\n'),
                    // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
                    rich: {
                      b: {
                        fontSize: 12,
                        color: '#fff',
                        padding: [5, 4, 5, 4],
                        backgroundColor: violet
                      }
                    }
                  },
                  // symbolSize: 0.1,
                  animationDelay: 1250
                }
              ]
            }
          },

          // {
          //   name: 'critically insufficient line',
          //   type: 'line',
          //   animationDelay: 1000,
          //   z: -1,
          //   showSymbol: false,
          //   markLine: {
          //     lineStyle: {
          //       normal: {
          //         type: 'solid',
          //         color: '#ba83b7',
          //         width: 3
          //       }
          //     },
          //     data: [
          //       [
          //         {
          //           coord: ['2030', column[1]],
          //           symbol: 'none',

          //           label: {
          //             position: 'middle'
          //           }
          //         },
          //         {
          //           coord: ['2030', 100],
          //           symbol: 'none'
          //         }
          //       ]
          //     ]
          //   },
            // markPoint: {
            //   data: [
            //     {
            //       name: 'critically insufficient label',
            //       coord: ['2030', 100],
            //       symbol: 'rect', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
            //       //   data: 20,
            //       label: {
            //         position: [5, 0],
            //         formatter: ['{b|+3-4°C}'].join('\n'),
            //         // formatter: ['{b|+3-4°\nErwärmung}'].join('\n'),
            //         rich: {
            //           b: {
            //             fontSize: 14,
            //             color: '#fff',
            //             padding: [3, 4, 5, 4],
            //             backgroundColor: '#ba83b7'
            //           }
            //         }
            //       },
            //       symbolSize: 0.1,
            //       animationDelay: 1250
            //     }
            //   ]
            // }
          // },

          {
            name: 'Line Historical emissions',
            data: values,
            type: 'line',
            showSymbol: false,
            itemStyle: {
              color: 'black'
            },
            lineStyle: {
              type: 'solid',
              color: 'black',
              width: 3
            }
            // areaStyle: {
            //     color: 'rgba(0, 0, 0, 0.2)'
            // }
          },

          {
            name: 'Line Current policy projections',
            data: valuesCurrentPolicyOne,
            type: 'line',
            animationDelay: 1200,
            lineStyle: {
              type: 'solid',
              color: grey,
              width: 1,
              opacity: 0.8,
            },
            stack: 'DifferenceUpperArea',
            showSymbol: false,
            markPoint: {
            }
          },

          {
            name: 'Line 1.5',
            type: 'line',
            animationDelay: 1200,
            connectNulls: true,
            data: valuesParis,
            lineStyle: {
              type: 'dotted',
              color: green
            },
            showSymbol: false,
            markPoint: {
              data: [
                {
                  name: 'lastPoint 1.5',
                  coord: ['2030', column[4]],
                  symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
                  //   data: 20,
                  itemStyle: {
                    color: 'white',
                    borderColor: green,
                    borderWidth: '2',
                    borderType: 'solid'
                  },

                  label: {
                    position: [-49, 9],
                    //   rotate: -15,
                    formatter: ['{b|+1,5°C\n}'].join('\n'),
                    rich: {
                      b: {
                        fontSize: 14,
                        color: green,
                        textBorderColor: 'white',
                        textBorderWidth: 4,
                      }
                    }
                  },
                  symbolSize: 8,

                  animationDelay: 1250
                },

              ]
            }
          },

          {
            name: 'Line NDC',
            type: 'line',
            animationDelay: 1200,
            connectNulls: true,
            data: valuesNDC,
            lineStyle: {
              type: 'dotted',
              color: violet
            },
            z: 3,
            showSymbol: false,
            markPoint: {
              data: [
                {
                  name: 'lastPoint NDC label',
                  coord: ['2030', valuesNDC[40]],
                  symbol: 'circle', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
                  //   data: 20,
                  itemStyle: {
                    color: 'white',
                    borderColor: violet,
                    borderWidth: '2',
                    borderType: 'solid'
                  },

                  label: {
                    position: [16, -2],
                    //   rotate: -15,
                    formatter: ['{b|Versprechen\n}'].join('\n'),
                    rich: {
                      b: {
                        fontSize: 14,
                        color: violet,
                        textBorderColor: 'white',
                        textBorderWidth: 4,
                        // padding: [1, -2, 1, 2],
                        // backgroundColor: 'rgba(255,255,255, 0.8)',
                      }
                    }
                  },
                  symbolSize: 8,

                  animationDelay: 1250
                },
                
              ]
            }
          },

          {
            name: 'Line Current Policy Two',
            type: 'line',
            animationDelay: 1200,
            connectNulls: true,
            data: valuesCurrentPolicyTwo,
            lineStyle: {
              type: 'solid',
              color: grey,
              width: 1,
              opacity: 0.8,
            },
            stack: 'confidence-band',
            showSymbol: false,
            // markPoint: {
            //   data: [
            //     {
            //       name: 'labelPolicy',
            //       value: 'akt. Kurs',
            //       xAxis: xCurrentPolicy.toString(),
            //       yAxis: yCurrentPolicy,
            //       symbol: 'rect',
            //       itemStyle: {
            //         color: 'none'
            //       },
            //       label: {
            //         position: isMobile ? [10, 54, 4, 0] : [20, 8, 4, 0],
            //         rotate: isMobile ? 44 : 0,
            //         formatter: ['{b|akt. Kurs\n}'].join('\n'),
            //         rich: {
            //           b: {
            //             fontSize: 14,
            //             color: 'black',
            //             textBorderColor: 'white',
            //             textBorderWidth: 4,
            //             // backgroundColor: 'rgba(255,255,255, 0.8)',
            //             // padding: [1, -4, 1, 1],
            //           }
            //         }
            //       },
            //       animationDelay: 1250
            //     }
            //   ]
            // }
          },

          {
            name: 'U',
            type: 'line',
            animationDelay: 1200,
            zlevel: -1,
            data: valuesDifferenceDownArea,
            lineStyle: {
              normal: {
                opacity: 0
              }
            },
            areaStyle: {
              normal: {
                color: grey
              }
            },
            stack: 'confidence-band',
            symbol: 'none'
          },
          {
            name: 't',
            type: 'line',
            animationDelay: 1200,
            zlevel: -1,
            data: valuesDifferenceUpArea,
            lineStyle: {
              normal: {
                opacity: 0
              }
            },
            areaStyle: {
              normal: {
                color: grey
              }
            },
            stack: 'DifferenceUpperArea',
            symbol: 'none'
          }
        ]
      }}
    />
  )
}
export { SparkLineSaudiaArabia }
